module.exports = __webpack_public_path__ + "img/ic_banner_pic.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/ic_banner_pic.png
// module id = 719
// module chunks = 0